import LineItemCreditRequestItem from '../../Domain/CreditMemo/LineItemCreditRequestItem';
import serviceHelper from '../../Helpers/serviceHelper';
import SearchParams from '../../Elements/SearchParams';
import LineItemCreditRequestSearchParams from '../../Contents/Operations/CreditMemo/LineItemCreditRequestSearchParams';
import AuthService from '../authService';

export default class LineItemCreditRequestService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const authService = AuthService.getInstance();

    let url = '/api/LineItemCreditRequest/GetAllBySearchingAsync?';

    const searchParams = new SearchParams(searchItem, LineItemCreditRequestSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    url += `searchParams=${searchParams.serializeForBackendCall()}`;
    // url += "&clearCache=" + clearCache;
    url += '&clearCache=true';

    return authService.CallBackendFunction(url);
  }

  static GetDataForCreditApply(searchItem, allItemInTheSearchSetAreSelected, selectedItems) {
    const searchParams = {
      Command: '',
      OrderBy: '',
      OrderDirection: '',
      PageNumber: 0,
      NumberOfElementsOnAPage: 0,
      SearchItem: {
        SearchItem: searchItem,
        AllItemInTheSearchSetAreSelected: allItemInTheSearchSetAreSelected,
        SelectedItems: selectedItems,
      },
    };
    const url = `/api/LineItemCreditRequest/GetDataForCreditApplyAsync?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=true`;

    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItemList(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new LineItemCreditRequestItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ApplyCredit(item) {
    const searchParams = new SearchParams(item.SearchItem, LineItemCreditRequestSearchParams, '', '', 0, 0);
    delete item.SearchItem;
    item = serviceHelper.ConvertAllPropertyToString(item);

    const JSONItem = JSON.stringify(item);

    const url = `/api/LineItemCreditRequest/ApplyCreditAsync?searchParams=${searchParams.serializeForBackendCall()}`;

    return AuthService.getInstance().CallBackendFunctionPut(url, JSONItem);
  }

  static ApplyTaxCredit(item) {
    const searchParams = new SearchParams(item.SearchItem, LineItemCreditRequestSearchParams, '', '', 0, 0);
    delete item.SearchItem;
    item = serviceHelper.ConvertAllPropertyToString(item);

    const JSONItem = JSON.stringify(item);

    const url = `/api/LineItemCreditRequest/ApplyTaxCreditAsync?searchParams=${searchParams.serializeForBackendCall()}`;

    return AuthService.getInstance().CallBackendFunctionPut(url, JSONItem);
  }
}
